const rentalItems = [
  {
    id: 'stockpot-trio',
    name: 'Stock Pot Trio',
    category: 'Cookware',
    price: 12000,
    description: 'Stainless steel stockpots with lids, perfect for soups and stews.',
    image:
      'https://images.unsplash.com/photo-1517248135467-4c7edcad34c4?auto=format&fit=crop&w=900&q=80',
  },
  {
    id: 'grill-kit',
    name: 'Grill Station Kit',
    category: 'Grilling',
    price: 15000,
    description: 'Portable burners and grill grates for outdoor cooking shows.',
    image:
      'https://images.unsplash.com/photo-1447078806655-40579c2520d6?auto=format&fit=crop&w=900&q=80',
  },
  {
    id: 'buffet-setup',
    name: 'Buffet Chafing Set',
    category: 'Buffet',
    price: 9000,
    description: 'Chafer stands, fuel cans, and princess pans for warm service.',
    image:
      'https://images.unsplash.com/photo-1470337458703-46ad1756a187?auto=format&fit=crop&w=900&q=80',
  },
  {
    id: 'prep-kits',
    name: 'Prep Island Kit',
    category: 'Prep',
    price: 6000,
    description: 'Mobile prep table, cutting boards, and sanitation station.',
    image:
      'https://images.unsplash.com/photo-1504674900247-0877df9cc836?auto=format&fit=crop&w=900&q=80',
  },
  {
    id: 'dinnerware-set',
    name: 'Dinnerware & Serveware',
    category: 'Serveware',
    price: 8000,
    description: 'Assorted plates, bowls, and serving utensils for plated service.',
    image:
      'https://images.unsplash.com/photo-1498654896293-37aacf113fd9?auto=format&fit=crop&w=900&q=80',
  },
];

export default rentalItems;
